import { render, staticRenderFns } from "./babsDetayUnvanCellRendere.vue?vue&type=template&id=6d337247&"
import script from "./babsDetayUnvanCellRendere.vue?vue&type=script&lang=js&"
export * from "./babsDetayUnvanCellRendere.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports